import { useEffect, useRef, useState } from 'react'
import './index.scss'
import { Button, Result, message } from 'antd'
import Register from './register'
import Api from '../../api/index'
import { removeToken } from '../../utils/cookie'
import {
  WECHAT_QR_EXPIRED_CODE,
  clearWechatQrSession,
  getApiPayload,
  getWechatQrHandoff,
} from '../../utils/wechatQr'

let handoffCleanupTimer = null

export default function WXHtml() {
  const [handoff] = useState(() => getWechatQrHandoff())
  const [confirmToken, setConfirmToken] = useState(handoff?.confirm_token || null)
  const [registrationToken, setRegistrationToken] = useState(
    handoff?.registration_token || null
  )
  const [confirming, setConfirming] = useState(false)
  const confirmingRef = useRef(false)
  const [expired, setExpired] = useState(false)

  const clearAll = () => {
    if (handoffCleanupTimer) {
      clearTimeout(handoffCleanupTimer)
      handoffCleanupTimer = null
    }
    removeToken()
    clearWechatQrSession()
  }

  useEffect(() => {
    document.title = 'iWudao'
    if (handoffCleanupTimer) {
      clearTimeout(handoffCleanupTimer)
      handoffCleanupTimer = null
    }
    return () => {
      handoffCleanupTimer = setTimeout(() => {
        removeToken()
        clearWechatQrSession()
        handoffCleanupTimer = null
      }, 0)
    }
  }, [])

  const closeWin = () => {
    clearAll()
    if (typeof window.WeixinJSBridge !== 'undefined') {
      window.WeixinJSBridge.call('closeWindow')
      return
    }
    document.addEventListener(
      'WeixinJSBridgeReady',
      () => window.WeixinJSBridge?.call('closeWindow'),
      false
    )
  }

  const confirmLogin = async () => {
    if (confirmingRef.current || !confirmToken) return
    confirmingRef.current = true
    setConfirming(true)
    try {
      const res = await Api.confirmWechatQr({
        scan_id: handoff.scan_id,
        confirm_token: confirmToken,
      })
      if (res.data.code === 0 && getApiPayload(res)?.status === 'confirmed') {
        setConfirmToken(null)
        closeWin()
      } else if (res.data.code === WECHAT_QR_EXPIRED_CODE) {
        clearWechatQrSession()
        setConfirmToken(null)
        setExpired(true)
      } else {
        message.error(res.data.msg)
      }
    } catch (error) {
      if (error?.response?.data?.code === WECHAT_QR_EXPIRED_CODE) {
        clearWechatQrSession()
        setConfirmToken(null)
        setExpired(true)
      } else {
        message.error(error?.response?.data?.msg || '确认失败，请稍后重试')
      }
    } finally {
      confirmingRef.current = false
      setConfirming(false)
    }
  }

  if (!handoff || expired) {
    return (
      <div className="wxHtmlContent">
        <Result title="请重新扫描二维码!" />
      </div>
    )
  }

  return (
    <div className="wxHtmlContent">
      {handoff.status === 'verified' ? (
        <div className="loginContentBox">
          <Result status="success" title="吾道科技登录确认" />
          <Button
            type="primary"
            className="loginBtn"
            onClick={confirmLogin}
            loading={confirming}
            disabled={confirming || !confirmToken}
          >
            登录/确认
          </Button>
          <Button className="closeBtn" onClick={closeWin} disabled={confirming}>
            取消
          </Button>
        </div>
      ) : handoff.status === 'registration_required' ? (
        <Register
          closeWin={closeWin}
          scanId={handoff.scan_id}
          codeType={handoff.code_type}
          registrationToken={registrationToken}
          onRegistrationTokenConsumed={() => {
            clearWechatQrSession()
            setRegistrationToken(null)
          }}
          onExpired={() => {
            clearAll()
            setExpired(true)
          }}
        />
      ) : (
        <Result title="请重新扫描二维码!" />
      )}
    </div>
  )
}
